<div style="position: relative; width: 100%; height: 100%;">
  <button style="position: absolute; top: 5px; right: 20px; z-index: 1000;" class="btn btn-sm btn-light border"
    (click)="togglePii()" [title]="isPiiRevealed ? ('HOME_COMPONENTS.PII.HIDE' | translate) : ('HOME_COMPONENTS.PII.REVEAL' | translate)">
    <fa-icon [icon]="isPiiRevealed ? faEye : faEyeSlash"></fa-icon>
  </button>

  @if (workOrders().length > 0 || workorderService.streamingInProgress()) {
    <ag-grid-angular style="width: 100%; height: 100%;"
      [ngClass]="['o-ag-grid', 'ag-grid-no-border-radius', themeClass]" [rowData]="streamAwareRowData()"
      [columnDefs]="columns()" [defaultColDef]="defaultColDef" [rowGroupPanelShow]="rowGroupPanelShow"
      [autoGroupColumnDef]="autoGroupColumnDef" [pivotMode]="false" [sideBar]="sideBar"
      [localeText]="localeText"
      [rowMultiSelectWithClick]="true" (selectionChanged)="onSelectionChanged($event)"
      (gridReady)="onGridReady($event)" [gridOptions]="gridOptions"
      (filterChanged)="filterChange($event)" (gridColumnsChanged)="rowGroup($event)"
      (columnVisible)="columnVisible($event)" (columnPivotModeChanged)="pivotChange($event)" [loading]="pending()"
      [getMainMenuItems]="getMainMenuItems" />
  }
</div>
